import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';

@jsonObject
export class PublicBrandBannerCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(MultimediaResponse)
  public readonly file!: MultimediaResponse;

  @jsonMember(MultimediaResponse)
  public readonly smallFile?: Nillable<MultimediaResponse>;
}
